import * as Sentry from "@sentry/react";
import type { ReactNode } from "react";

function ErrorFallback() {
	return (
		<div className="flex min-h-[400px] items-center justify-center">
			<div className="text-center">
				<h2 className="text-lg font-semibold text-[#1e1e20]">Something went wrong</h2>
				<p className="mt-2 text-sm text-[#6b7280]">
					An unexpected error occurred. Please try refreshing the page.
				</p>
				<button
					type="button"
					onClick={() => window.location.reload()}
					className="mt-4 rounded-md bg-[#4f46e5] px-4 py-2 text-sm font-medium text-white hover:bg-[#4338ca]"
				>
					Refresh Page
				</button>
			</div>
		</div>
	);
}

export function AppErrorBoundary({ children }: { children: ReactNode }) {
	return <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>;
}
